import { jsxs as l, jsx as e } from "react/jsx-runtime";
import { clsx as m } from "../../node_modules/.pnpm/clsx@2.1.1/node_modules/clsx/dist/clsx.js";
import { useState as c, useEffect as h } from "react";
import { RocheUIHeadline as d } from "../headline/roche-headline.js";
import { RocheUIScaleOnScroll as g } from "../scale-on-scroll/roche-scale-on-scroll.js";
import f from "./roche-stage-home.module.scss.js";
const I = ({
  statement: s,
  Image: o,
  slot: t,
  children: i
}) => {
  const [a, r] = c(!1);
  h(() => {
    r(!0);
  }, []);
  const n = m({
    "stage-home": !0,
    "stage-home--original-branding": s === "Doing now what patients need next",
    "stage-home--heading-visible": a
  });
  return /* @__PURE__ */ l("div", { className: n, slot: t, children: [
    /* @__PURE__ */ e(d, { headline: s, level: "1" }),
    /* @__PURE__ */ e(g, { children: o }),
    /* @__PURE__ */ e("div", { className: f["stage-home__teasers"], children: i })
  ] });
};
export {
  I as RocheUIStageHome
};
